'use client';
import React from 'react';
import { SliceZone } from '@prismicio/react';
import { components } from 'slices';
import {
  Main,
  GradientText,
  HeroContainer,
  Title,
  TextCenter,
  Container,
  BoostContainer,
  Description,
  WhyContainer,
  WhyImageWrapper,
  WhyContentWrapper,
  BenefitsContainer,
  BenefitsGrid,
  BenefitCard,
  BenefitCardTitle,
  BenefitCardDescription,
  ProgramContainer,
  ProgramCardsContainer,
  ProgramCard,
  ProgramIconWrapper,
  ProgramCardTitle,
  FeaturesList,
  FeatureItem,
  Bullet,
  FeatureContent,
  PillarsPillarsContainer,
  PillarsSlideContainer,
  PillarsSlideContent,
  PillarsTextContent,
  PillarsSlideTitle,
  PillarsDescription,
  StartContainer,
  StartGridContainer,
  StartColumn,
  StartColumnTitle,
  StartDescription,
  StartButtonWrapper,
  ReferencesContainer,
  ReferencesGrid,
  ReferencesCard,
  BackgroundLinearContainer,
  SliceContainer,
  WhyContentTitle,
  CenterElement,
  BackgroundHeroContainer,
} from './Acculturation.style';
import BtnGetStarted from 'common/components/Button/BTNGetStarted';
import { PrismicRichText } from '@prismicio/react';
import NextImage from 'common/components/NextImage';
import Carousel from 'common/components/Carrousel';
import TitleDescription from 'common/components/TitleDescription';
import { calendar } from 'react-icons-kit/entypo/calendar';
import { mail } from 'react-icons-kit/entypo/mail';
import { Icon } from 'react-icons-kit';

const AcculturationPage = ({ data }) => {
  return (
    <Main>
      <HeroContainer>
        <BackgroundHeroContainer />
        <Container>
          <TitleDescription
            title={data.title}
            description={data.description}
            descriptionColor="black"
            descriptionCenter={true}
            data-aos="fade-in"
          />
          <BtnGetStarted label={data.btn_contact} />
        </Container>
      </HeroContainer>
      <Container>
        <BoostContainer>
          <Title data-aos="fade-in">{data.boost_your_skill_head_line}</Title>
          <Description data-aos="fade-in">
            <PrismicRichText field={data.boost_your_skill_sub_title} />
          </Description>
        </BoostContainer>
        <WhyContainer>
          <WhyImageWrapper data-aos="fade-in">
            <NextImage
              field={data.boost_your_skill_image}
              objectFit="contain"
              priority
            />
          </WhyImageWrapper>
          <WhyContentWrapper>
            <WhyContentTitle data-aos="fade-in">
              <GradientText>{data.boost_your_skill_title}</GradientText>
            </WhyContentTitle>
            <Description data-aos="fade-in">
              <PrismicRichText field={data.boost_your_skill_description} />
            </Description>
            <div>
              <BtnGetStarted label={data.boost_your_skill_btn_start} />
            </div>
          </WhyContentWrapper>
        </WhyContainer>
        <BenefitsContainer>
          <BenefitsGrid>
            {data.boost_your_skill_advantage.map((benefit, index) => (
              <BenefitCard key={index}>
                <BenefitCardTitle data-aos="fade-in">
                  {benefit.title}
                </BenefitCardTitle>
                <BenefitCardDescription data-aos="fade-in">
                  <PrismicRichText field={benefit.description} />
                </BenefitCardDescription>
              </BenefitCard>
            ))}
          </BenefitsGrid>
        </BenefitsContainer>
        <ProgramContainer>
          <TitleDescription
            asTitle="h2"
            data-aos="fade-in"
            title={data.our_program_title}
            description={data.our_program_description}
            descriptionColor={'black'}
            descriptionCenter={true}
          />
          <ProgramCardsContainer>
            {data.our_programs.map((program, index) => (
              <ProgramCard key={index}>
                <ProgramIconWrapper data-aos="fade-in">
                  <NextImage
                    field={program.logo}
                    objectFit="contain"
                    priority
                  />
                </ProgramIconWrapper>
                <ProgramCardTitle data-aos="fade-in">
                  {program.title}
                </ProgramCardTitle>
                <Description data-aos="fade-in">
                  <PrismicRichText field={program.description} />
                </Description>
              </ProgramCard>
            ))}
          </ProgramCardsContainer>
        </ProgramContainer>
      </Container>

      <BackgroundLinearContainer>
        <Container>
          <TextCenter>
            <Title data-aos="fade-in">
              <GradientText>{data.why_choose_us_title}</GradientText>
            </Title>
          </TextCenter>
          <FeaturesList>
            {data.why_choose_us_description.map((why_choose_us, index) => (
              <FeatureItem key={index} data-aos="fade-in">
                <Bullet />
                <FeatureContent>
                  <PrismicRichText field={why_choose_us.description} />
                </FeatureContent>
              </FeatureItem>
            ))}
          </FeaturesList>
          <CenterElement>
            <BtnGetStarted label={data.why_choose_us_cta} />
          </CenterElement>
        </Container>
      </BackgroundLinearContainer>
      <Container>
        <PillarsPillarsContainer>
          <TextCenter>
            <Title>
              <GradientText data-aos="fade-in">
                {data.pillar_of_our_training_title}
              </GradientText>
            </Title>
          </TextCenter>
          <PillarsSlideContainer>
            <Carousel
              data-aos="fade-in"
              items={data.pillar_of_our_training.map((pillar, index) => (
                <PillarsSlideContent key={index} bgImage={pillar.picture.url}>
                  <PillarsTextContent>
                    <PillarsSlideTitle>{pillar.title}</PillarsSlideTitle>
                    <PillarsDescription>
                      <PrismicRichText field={pillar.description} />
                    </PillarsDescription>
                  </PillarsTextContent>
                </PillarsSlideContent>
              ))}
            />
          </PillarsSlideContainer>
        </PillarsPillarsContainer>
        <SliceZone slices={data.slices6} components={components} />
        <StartContainer data-aos="fade-in">
          <TextCenter>
            <Title data-aos="fade-in">
              <GradientText>{data.start_trainning_title}</GradientText>
            </Title>
          </TextCenter>
          <StartGridContainer data-aos="fade-in">
            {data.start_trainning_content.map((start, index) => (
              <StartColumn key={index} data-aos="fade-in">
                <StartColumnTitle>
                  <GradientText>{start.title}</GradientText>
                </StartColumnTitle>
                <StartDescription>
                  <PrismicRichText field={start.description} />
                </StartDescription>
                {start.link ? (
                  <StartButtonWrapper href={start.link}>
                    <Icon icon={index ? calendar : mail} size={20} />
                    <span>{start.text_button}</span>
                  </StartButtonWrapper>
                ) : null}
              </StartColumn>
            ))}
          </StartGridContainer>
        </StartContainer>
        <ReferencesContainer>
          <TitleDescription
            data-aos="fade-in"
            asTitle="h2"
            title={data.referal_customer_title}
            description={data.referal_customer_description}
            descriptionColor={'black'}
            descriptionCenter={true}
          />
          <ReferencesGrid>
            {data.referal_customer_container.map((referencesCard, index) => (
              <ReferencesCard
                data-aos="fade-in"
                key={index}
                bgColor={referencesCard.background_color}
              >
                <NextImage
                  field={referencesCard.icon}
                  objectFit="contain"
                  priority={true}
                />
                <Description>
                  <PrismicRichText field={referencesCard.description} />
                </Description>
              </ReferencesCard>
            ))}
          </ReferencesGrid>
          <TextCenter>
            <Description data-aos="fade-in">
              <PrismicRichText field={data.referal_customer_notice} />
            </Description>
          </TextCenter>
        </ReferencesContainer>
        <SliceContainer data-aos="fade-in">
          <SliceZone slices={data.slices9} components={components} />
        </SliceContainer>
      </Container>
      <BackgroundLinearContainer>
        <Container data-aos="fade-in">
          <SliceZone slices={data.slices10} components={components} />
        </Container>
      </BackgroundLinearContainer>
      <Container>
        <SliceContainer paddingBottom={0.1}>
          <SliceZone slices={data.slices11} components={components} />
        </SliceContainer>
        <SliceZone slices={data.slices} components={components} />
        <SliceContainer data-aos="fade-in">
          <SliceZone slices={data.slices12} components={components} />
        </SliceContainer>
      </Container>
    </Main>
  );
};

export default AcculturationPage;
